import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextButton from '@spothero/ui/text-button';

const GettingThere = ({instructions}) => {
    const [showFullInstructions, setShowFullInstructions] = useState(false);
    const toggleFullInstructions = () => setShowFullInstructions(show => !show);
    const classes = classNames('SpotDetails-section', 'GettingThere', {
        'GettingThere-show-full-instructions': showFullInstructions,
    });
    const formattedInstructions = instructions.replace(/\r?\n/g, '<br>');

    return (
        <div className={classes}>
            <h4 className="subtitle">Getting There</h4>
            <div className="preview-container">
                <p
                    className="instructions"
                    dangerouslySetInnerHTML={{__html: formattedInstructions}}
                />
                <div className="overlay" />
            </div>
            <TextButton className="read-more" onClick={toggleFullInstructions}>
                Show More
            </TextButton>
        </div>
    );
};

GettingThere.propTypes = {
    instructions: PropTypes.string.isRequired,
};

export default GettingThere;
